import React from "react";
import { Typography } from "@mui/material";
import EAButton from "../../components/common/EAButton";
import ReportsIllustration from "./ReportsIllustration";
import useStyles from "./style";
import i18next from "i18next";

function ReportsEmptyState({ onGenerate }) {
  const { classes } = useStyles();

  return (
    <div className={classes.emptyStateContainer}>
      {/* Left side - Illustration */}
      <div className={classes.emptyStateIllustrationContainer}>
        <ReportsIllustration />
      </div>

      {/* Right side - Content */}
      <div className={classes.emptyStateContentContainer}>
        <Typography variant="h6" className={classes.emptyStateTitle}>
          {i18next.t("GENERATE_REPORT")}
        </Typography>

        <Typography variant="body2" className={classes.emptyStateDescription}>
          {i18next.t("EXPORTS_DESCRIPTION")}
        </Typography>

        <div>
          <EAButton
            content={i18next.t("continue")}
            colorVariant="primary"
            size="small"
            onClick={onGenerate}
            sx={{
              padding: "6px 16px",
              fontSize: "0.875rem"
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ReportsEmptyState;
